module.exports = __webpack_public_path__ + "img/Specials.b1505762.jpg";